import * as React from 'react';
import CheckIcon from './images/icon-check-bullet-point.svg';
import styles from './PlanCardColumn.module.css';
import { PlanFeatureItem } from './PlanFeatures';

type Props = {
  item?: PlanFeatureItem;
  name?: string;
};

const FeatureColumn: React.FC<Props> = ({ item, name }) => {
  const normalizedItem: PlanFeatureItem =
    item || { type: 'feature', text: name || '', variant: true };

  if (!normalizedItem.text) {
    return null;
  }

  if (normalizedItem.type === 'sub_feature') {
    return (
      <li className={styles.subFeatureRow}>
        <span className={styles.subFeatureText}>- {normalizedItem.text}</span>
      </li>
    );
  }

  const featureTextClassName =
    normalizedItem.type === 'feature_section'
      ? styles.featureSectionText
      : styles.featureText;
  const { text, emphasisPrefix } = normalizedItem;
  const hasEmphasisPrefix =
    !!emphasisPrefix && text.startsWith(emphasisPrefix);
  const suffixText = hasEmphasisPrefix ? text.slice(emphasisPrefix.length) : '';

  return (
    <li>
      <span className={styles.featureRow}>
        <CheckIcon className={styles.featureIcon} />
        <span className={featureTextClassName}>
          {hasEmphasisPrefix ? (
            <>
              <strong className={styles.featureEmphasis}>{emphasisPrefix}</strong>
              {suffixText}
            </>
          ) : (
            text
          )}
        </span>
      </span>
    </li>
  );
};

export default FeatureColumn;
